'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUIBlanket = function AUIBlanket(_ref) {
    var style = _ref.style,
        onClick = _ref.onClick;
    return _react2.default.createElement('div', {
        className: 'aui-blanket',
        tabIndex: '0',
        style: _extends({ zIndex: 2980 }, style),
        'aria-hidden': false,
        onClick: onClick
    });
};

AUIBlanket.displayName = 'AUIBlanket';
AUIBlanket.propTypes = {
    /**
     * Custom style for the mask
     */
    style: _propTypes2.default.object,
    /**
     * Click event to trigger on an element
     */
    onClick: _propTypes2.default.func
};

exports.default = AUIBlanket;
//# sourceMappingURL=AUIBlanket.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIBlanket.js
// module id = 179
// module chunks = 0